/** @jsx  jsx */
import { css } from '@emotion/core';
import { typography } from '../../../../../styles/typography';
import { colorsPalette, hexToRgba } from '../../../../../styles/colors';
import { MediaQueries } from '../../../../../styles/Grid';

export const dropdownSolutions = css(typography.effra16, {
  marginRight: 10,

  [MediaQueries.mdAndUp]: {
    display: 'inline-block',
    position: 'relative',
  },
});

export const modalWrapper = css({
  height: '100%',
  left: 0,
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 10,

  [MediaQueries.lgAndUp]: {
    boxShadow: `0 10px 80px ${hexToRgba(colorsPalette.black, 0.2)}`,
    height: 327,
    left: -32,
    position: 'absolute',
    top: -32,
    width: 405,
  },
});

export const dropdownButton = css({
  [MediaQueries.lgAndUp]: {
    margin: '32px 32px 0',
  },
});

export const modalCustomCss = {
  position: 'absolute',
};
